import NavigationLink from '../Components/NavigationLink.js';

const Nav = ({ id, pages, page, setPage }) => 
    <nav id={id}>{
        Object.entries(pages).map(([name, text]) =>
            <NavigationLink
                key={name}
                page={page}
                name={name}
                text={text}
                setPage={setPage}
            />
        )
    }</nav>

export default Nav;